import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { CallStore } from '../../app/calls/CallStore';
import { VoiceLogStore } from '../../app/calls/voiceLogStore';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRecordVinyl } from '@fortawesome/free-solid-svg-icons';

interface VoiceLogHandlerProps extends React.HTMLAttributes<HTMLDivElement> {
    callStore?: CallStore;
    voiceLogStore?: VoiceLogStore;
}

const VoiceLogHandler = React.forwardRef<HTMLButtonElement, VoiceLogHandlerProps>((
    {
        callStore,
        voiceLogStore
    },
    ref
): React.ReactElement => {
    const startVoiceLog = () => {
        if (callStore!.currentCall) {
            voiceLogStore!.startVoicelog(callStore!.currentCall);
        }
    }

    const stopVoiceLog = () => {
        if(voiceLogStore!.voiceLog && callStore!.currentCall) {
            voiceLogStore!.endVoiceLog(callStore!.currentCall);
        }
    }

    return (
        <button
            ref={ref}
            className={clsx(
                'btn',
                voiceLogStore!.voiceLog ? 'btn-record-stop' : 'btn-primary-record'
            )}
            onClick={voiceLogStore!.voiceLog ? stopVoiceLog : startVoiceLog}
        >
            <FontAwesomeIcon icon={faRecordVinyl} className="mr-2" />
            {voiceLogStore!.voiceLog ? 'Stop' : 'Record'}
        </button>
    );
});

VoiceLogHandler.displayName = 'VoiceLogHandler';

export default inject(
    'callStore',
    'voiceLogStore'
)(observer(VoiceLogHandler));
